import { HttpService } from '../../services/HttpService';
import { store } from '../../configureStore';
import * as constants from './constants';
import { apiUrls } from './apiConfig';
import { getAEMBaseUrl } from '../../services/UrlMapperService';

// Fall back When getPlanReferenceData fails
import PLAN_REFERENCE_DATA from '../../assets/cq/productreference.model.json';
import { getPageName, isMVA, isWHWP2 } from '../../components/common/Helpers';

const PlanRefData = PLAN_REFERENCE_DATA;

export const getProductRefData = (sorId, planId, planRefData) => {
  const plansInfo = [];
  if (!sorId && !planId) return null;
  if (planRefData) {
    Object.keys(planRefData).forEach((id) => {
      if (sorId === id || planId === id) {
        plansInfo.push(planRefData[id]);
      }
    });
  }
  return plansInfo;
};

export const getProductData = (planId, planRef) => {
  if (!planId || !planRef) return null;
  const plansInfo = getProductRefData('', planId, planRef);
  return plansInfo?.[0] || null;
};

export async function fetchPlansData() {
  try {
    const apiURL = `${getAEMBaseUrl('content/vcg')}${apiUrls.productReferenceUrl}`;
    const response = await HttpService.get(apiURL);
    return response?.data && response.status === 200 ? response.data : PlanRefData;
  } catch (error) {
    console.error(error);
    return PlanRefData;
  }
}

export const checkPlanReferenceData = (planReferenceData) => {
  if (!planReferenceData || Object.keys(planReferenceData).length === 0) {
    if (isMVA() && getPageName() === 'getStreamingDevices' && isWHWP2()) {
      const apiURL = `${getAEMBaseUrl('content/vcg')}${apiUrls.productReferenceUrl}`;
      const apiResponse = HttpService.get(apiURL);
      Promise.all([apiResponse]).then((res) => {
        if (res?.[0] && res?.[0]?.data && res?.[0]?.status === 200) {
          store.dispatch({ type: constants.UPDATE_PLANS_DATA, response: res?.[0]?.data });
          return res?.[0]?.data;
        }
        store.dispatch({ type: constants.UPDATE_PLANS_DATA, response: PlanRefData });
        return PlanRefData;
      });
    } else {
      fetchPlansData()
        .then((res) => {
          const data = res || PlanRefData;
          store.dispatch({ type: constants.UPDATE_PLANS_DATA, response: data });
        })
        .catch((error) => {
          console.log('error on fetchPlansData', error);
        });
    }
  }

  return planReferenceData;
};

export const getPlanReferenceData = () => store.getState().plansReferenceData.output;

export const getPlansData = (prodRefData) => prodRefData?.output || {};

export const getChoiceOfferQualified = (promotions, selectedSpecialPromo) => {
  if (selectedSpecialPromo?.promoType?.toLowerCase() === 'perk') {
    let spoId = null;
    const promoIntents = promotions?.[0]?.promoIntent;
    if (promoIntents) {
      for (const promo of promoIntents) {
        if (selectedSpecialPromo?.sedOfferId === promo?.offerId) {
          spoId = selectedSpecialPromo?.spoId;
          break;
        }
      }
    }
    return spoId;
  }
};
